import type {PromiseBasedRecordEditationDataService, RecordEditationAction,} from '../record-editation';
import type {RecordEditation} from 'typings/portaro.be.types';
import type {Observable} from 'rxjs';
import {from} from 'rxjs';
import {GenericEditationAction} from './generic-editation-action';

export class SetFieldValueAction extends GenericEditationAction implements RecordEditationAction {
    constructor(private backend: PromiseBasedRecordEditationDataService, private field) {
        super();
    }

    public executeAction(editationObject: RecordEditation): Observable<RecordEditation> {
        return from(this.backend.setFieldValue(editationObject.id, this.field.idPath, this.field.value));
    }

    public equals(otherAction: RecordEditationAction) {
        if (SetFieldValueAction.isSetFieldValueAction(otherAction)) {
            return this.field.value === otherAction.field.value && this.field.id === otherAction.field.id;
        } else {
          return false;
        }
    }

    /**
     * User-defined type guard (to check if action is of type 'SetFieldValueAction').
     *
     * @param {RecordEditationAction} action - A RecordEditationAction object
     * @return {action is SetFieldValueAction}
     *
     */
    public static isSetFieldValueAction(action: RecordEditationAction): action is SetFieldValueAction {
        return action instanceof SetFieldValueAction;
    }
}
